/* RESPONSIBLE TEAM: team-inbox-experience */
import type { CustomInputRuleConfig } from '@intercom/composer-ember/lib/config/composer-config';
import type { EditorState } from 'prosemirror-state';
import type CustomEmojiService from 'embercom/services/custom-emoji-service';

export function createCustomEmojiInputRule(
  customEmojiService: CustomEmojiService,
): CustomInputRuleConfig {
  return {
    type: 'custom',
    matcher: /(\s|^):([\w-]+):$/,
    handler(state: EditorState, match: string[], start: number, end: number) {
      let identifier = match[2];
      let customEmoji = customEmojiService.getCustomEmoji(identifier);

      if (!customEmoji) {
        return null;
      }

      let inlineImageNode = state.schema.nodes.inlineImage.create({
        src: customEmoji.src,
        text: customEmoji.alt || customEmoji.identifier,
        type: 'inlineImage',
        className: 'custom-emoji',
      });

      return state.tr.replaceWith(start + match[1].length, end, inlineImageNode);
    },
  };
}
